import React, { Component } from 'react';
import { Link } from 'react-router';

class ActiveLink extends Component {
    render() {

        const { path, location } = this.props
        
        let isActive = false;

        if( path && location ){
            isActive = path == location ? true : false;
        }

        const className = isActive ? 'current' : '';

        return <Link {...this.props} activeClassName={className} />
    }
}

export default ActiveLink;



// WEBPACK FOOTER //
// src/client/components/common/link/ActiveLink.js